<template>
  <div>
    <nav class="navbar is-link">
      <router-link :to="{ name: 'home' }">
        <div class="imageNav center">
          <img src='../assets/img/logo_affixe.svg' alt="Une solution Quadra Diffusion"
              class="center"/>
        </div>
      </router-link>
      <div class="navbar-menu"
           v-bind:class="{ 'is-active': isBurgerOn }">
        <div class="navbar-end">
          <div class="navbar-item">
            <societe-menu></societe-menu>
          </div>
          <div class="navbar-item">
            <div class="separation-bar-header"></div>
          </div>
          <div class="navbar-item">
            <app-account-menu></app-account-menu>
          </div>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import Bowser from 'bowser';
import societeMenu from '@/components/menu/societeMenu';
import AppAccountMenu from './menu/AccountMenu';

const user = createNamespacedHelpers('user');

export default {
  name: 'app-header',
  components: {
    AppAccountMenu,
    societeMenu,
  },
  data() {
    return {
      msg: '',
      isBurgerOn: false,
      subMenu: this.getDefaultMenuValues(),
      isTouch: false,
      dropDownActif: false,
    };
  },
  methods: {
    toggleBurger() {
      this.isBurgerOn = !this.isBurgerOn;
      return true;
    },
    getDefaultMenuValues() {
      return {
        catalogue: false,
        client: false,
        historique: false,
      };
    },
    toggleSubMenu(id) {
      if (!this.isTouch) {
        return true;
      }
      const backup = this.subMenu[id];
      this.subMenu = this.getDefaultMenuValues();
      this.subMenu[id] = !backup;
      return true;
    },
    clearMenu() {
      this.subMenu = this.getDefaultMenuValues();
      this.isBurgerOn = false;
    },
  },
  computed: {
    ...user.mapGetters({
      utilisateur: 'user',
    }),
  },
  mounted() {
    const browser = Bowser.getParser(window.navigator.userAgent);
    const browserOs = browser.getOSName(true);
    this.isTouch = ['ios', 'android'].includes(browserOs);
  },
};
</script>

<style scoped>

</style>
